import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import DashboardLayout from "../../../examples/LayoutContainers/DashboardLayout";
import { ShimmerPostList } from "react-shimmer-effects";
import JensCodesListComponent from "../../../components/Definition/JensCodes/JensCodesListComponent";
import { deleteJensCode, getJensCodes } from "../../../actions/reports/jens_codes";

export default function JensCodeScreen() {
    const [jensCodes, setJensCodes] = useState({ data: [], links: {} });
    const [loading, setLoading] = useState(true);
    const [status, setStatusDelete] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();


    useEffect(() => {
        setLoading(true);
        const fetchApi = async () => {
            const params = new URLSearchParams(searchParams);
            try {
                const usersData = await getJensCodes(params.toString());
                setLoading(false);
                setJensCodes(usersData.status !== "error" ? usersData.message : { data: [], links: {} });
            } catch (error) {
                toast.error('خطا در اتصال به سرور!');
                setLoading(false);
            }
        };

        fetchApi();
    }, [searchParams,status]);

    return (
        <DashboardLayout>
            {loading ? <ShimmerPostList postStyle="STYLE_THREE" col={1} row={3} gap={30} /> : <JensCodesListComponent lists={jensCodes} deleteInvoke={async(id)=>{
                const prompt = window.confirm("آیا میخواهید کد کالا حذف شود ؟ با این کار گزارشات وابسته از بین خواهد رفت")
                if(prompt){
                    const response = await deleteJensCode(id);
                    if (response.status === "success") {
                        toast.success("کد کالا حذف شد!");
                        setStatusDelete(true);
                    } else {
                        toast.error("خطا در حذف گروه کد کالا");
                    }
                }
            }} />}
        </DashboardLayout>
    );
}
